import { ApiFile } from '@new/types';
import { FileItem } from '@new/features/lessons/components/FileCard/FileCard';

export const createFileData = (uploadedFileData: any, fileName: string): ApiFile => ({
  url: uploadedFileData.url,
  pid: uploadedFileData.pid || fileName,
  type: uploadedFileData.type || undefined,
  description: uploadedFileData.description || undefined,
  id: uploadedFileData.id,
  updatedAt: uploadedFileData.updatedAt || new Date(),
  createdAt: uploadedFileData.createdAt || new Date(),
});

export const mapFileToItem = (
  file: any,
  status: FileItem['status'] = 'completed'
): FileItem | null => {
  if (!file) return null;
  return {
    id: file.id,
    name: file.pid || file.name || 'Unknown file',
    url: file.url,
    size: file.size,
    status,
  };
};
